import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'translateArrayKeys',
    standalone: false
})
export class TranslateArrayKeysPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform<T extends Record<string, any>>(arr: T[], keys: Array<keyof T>): T[] {
        return arr.map(obj => {
            keys.forEach(key => {
                const value = obj[key];
                if (typeof value === 'string' && value) {
                    obj[key] = this.translateService.instant(value) as T[typeof key];
                }
            });
            return obj;
        });
    }
}
